<!-- სადაზღვეო პერიოდი -->
<div class="filled" [ngClass]="!editModeMap[3] ? 'success' : 'danger'">
<div class="row align-items-center filled-row justify-content-xs-center" *ngIf="!editModeMap[3]">
  <div class="col filled-title">
    სადაზღვევო პერიოდი
  </div>
  <div class="col">
    <div class="d-flex flex-column">
      <p>
        {{this.policy.InsuranceDays.days}} დღე
      </p>
    </div>
  </div>
  <div class="col edit-btn">
    <button class="ml-m@s g-b--w0 g g--alignCenter g--nowrap cur-p edit ms-auto d-flex" (click)="onEdit(3)">
      <div class="mr-xs fz-12" style="color: #737373;">ცვლილება</div>
      <i class="fas fa-pen"></i>
    </button>
  </div>
</div>
<form [formGroup]="form">
  <div class="row edit-row position-relative" *ngIf="editModeMap[3]">

      <div class="hidden-radio col">
        <input type="radio" formControlName="days" value="30" id="30"><label for="30">
          30 დღე</label>
      </div>
      <div class="hidden-radio col">
        <input type="radio" formControlName="days" value="60" id="60"><label for="60">
          60 დღე</label>
      </div>
      <div class="hidden-radio col">
        <input type="radio" formControlName="days" value="90" id="90"><label for="90">
          90 დღე</label>
      </div>
      <div class="hidden-radio col">
        <input type="radio" formControlName="days" value="180" id="180"><label for="180">
          180 დღე</label>
      </div>
      <div class="hidden-radio col">
        <input type="radio" formControlName="days" value="365" id="365"><label for="365">
          365 დღე</label>
      </div>

    <div class="done" (click)="done(3)">
      შენახვა
    </div>
  </div>
</form>
</div>
